import ModalBase, { IModalBaseProps, ModalBaseRefType } from "../../../../../Base/ModalBase";
import { useRef } from "react";
import BoletoBoletoObterLinkForm, { IBoletoBoletoObterLinkFormRef } from "./BoletoObterLinkForm";

export interface IBoletoObterLinkFormModalProps extends IModalBaseProps {
    codTitulo : number;
}
export default function BoletoObterLinkFormModal({
    codTitulo,
    title,
    ...props
}:IBoletoObterLinkFormModalProps) {
    title = title ?? "Obter link";

    const refModal = useRef<ModalBaseRefType|null>(null);
    const refForm = useRef<IBoletoBoletoObterLinkFormRef|null>(null);
    
    return <ModalBase 
        ref={refModal} 
        title={title} 
        footer={<></>}
        propsButtonOpen={{
            size : "small"
        }}
        {...props}
    >
        <BoletoBoletoObterLinkForm 
            ref={refForm}
            onCancelar={() => refModal.current?.fechar()}
            onSuccess={(url) => {
                refModal.current?.fechar();
                
                window.setTimeout(() => {
                    /* Por questões de compatibilidade com o Safari */
                    window.open(url, "_blank", "noreferrer");
                }, 1)
            }}
            initialValues={{
                codTitulo
            }}
        />
    </ModalBase>;
}
